import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-chained-backend';
import { initReactI18next } from 'react-i18next';
import { baseConfig } from 'src/i18n.config';

import deDE from 'src/locales/de-DE/common.json';
import enUS from 'src/locales/en-US/common.json';
import en from 'src/locales/en/common.json';
import esAR from 'src/locales/es-AR/common.json';
import frCA from 'src/locales/fr-CA/common.json';

const ROOT = document.documentElement;

export const defaultNS = 'common';
export const resources = {
  'en': { common: en },
  'en-US': { common: enUS },
  'de-DE': { common: deDE },
  'es-AR': { common: esAR },
  'fr-CA': { common: frCA },
} as const;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...baseConfig,
    ...resources,
    defaultNS,
    ns: ['common'],
  });

i18n
  .on('languageChanged', (lng: string) => {
    ROOT.setAttribute('lang', lng);
    ROOT.setAttribute('xml:lang', lng);
  });

export { i18n, i18n as i18nInstance };
